import { api } from '../../lib/api';

const API_BASE = (import.meta.env.VITE_API_URL || '').replace(/\/+$/, '');

export const documentService = {
  /**
   * Get document features from Paperless (document_types, correspondents, tags, etc.)
   * Used to populate the DocumentType select in the upload form.
   */
  async getDocumentFeatures() {
    const data = await api.get('/api/docPaper/document-features');
    return data || { document_types: [], correspondents: [], tags: [], custom_fields: [], storage_paths: [] };
  },

  /**
   * Upload a document to a product.
   * @param {FormData} formData - Must include: ProductID, ProductTypeName, ProductCode, ProductManufacturer, DocumentType, document (file). Optional: ProductFamily (if Add to Family), Description
   * @param {Function} [onProgress] - Optional callback with { percent } for upload progress (0-100)
   */
  async uploadProductDocument(formData, onProgress) {
    if (onProgress) {
      return await api.postFormDataWithProgress('/api/docPaper/upload-product-document', formData, onProgress);
    }
    return await api.postFormData('/api/docPaper/upload-product-document', formData);
  },

  /**
   * Upload a document to an asset.
   * @param {FormData} formData - Must include: AssetID, AssetTechCode, HierarchicalLevel[1], HierarchicalLevel[2] (optional), DocumentType, Description (optional), document (file)
   * @param {Function} [onProgress] - Optional callback with { percent } for upload progress (0-100)
   */
  async uploadAssetDocument(formData, onProgress) {
    if (onProgress) {
      return await api.postFormDataWithProgress('/api/docPaper/upload-asset-document', formData, onProgress);
    }
    return await api.postFormData('/api/docPaper/upload-asset-document', formData);
  },

  /**
   * Upload a document to a work order.
   * @param {FormData} formData - Must include: WorkOrderID, DocumentType, Description (optional), document (file)
   * @param {Function} [onProgress] - Optional callback with { percent } for upload progress (0-100)
   */
  async uploadWorkOrderDocument(formData, onProgress) {
    if (onProgress) {
      return await api.postFormDataWithProgress('/api/docPaper/upload-work-order-document', formData, onProgress);
    }
    return await api.postFormData('/api/docPaper/upload-work-order-document', formData);
  },

  /**
   * Devuelve la URL canónica del endpoint del backend para servir el contenido
   * de un documento (Paperless o MinIO, indistintamente).
   *
   * Pensada para usarse como `href` en un <a target="_blank">. Como el endpoint
   * está en el mismo origen que el frontend (Traefik en auriga.coexpan.com),
   * la cookie HttpOnly de auth se envía automáticamente y no hace falta JS.
   *
   * @param {number|string} id - mr_documents.id (NO PaperlessID)
   * @param {object} [opts]
   * @param {boolean} [opts.download] - true ⇒ Content-Disposition: attachment
   * @returns {string}
   */
  getDocumentContentUrl(id, { download = false } = {}) {
    const qs = download ? '?download=true' : '';
    return `/api/docPaper/document/${id}/content${qs}`;
  },
};
